(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hc-collection-showcase"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hc-collection-carousel')) {
  customElements.define('hc-collection-carousel', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => {
        this.grid = this.querySelector('[data-carousel-grid]');
        this.controls = this.querySelector('[data-carousel-controls]');
        this.dots = this.querySelector('[data-carousel-dots]');
        this.arrows = this.querySelector('[data-carousel-arrows]');
        this.previous = this.querySelector('[data-carousel-previous]');
        this.next = this.querySelector('[data-carousel-next]');
        if (!this.grid || !this.controls || !this.dots || !this.arrows || !this.previous || !this.next) return;

        this.events = new AbortController();
        const signal = this.events.signal;
        this.previous.addEventListener('click', () => this.step(-1), { signal });
        this.next.addEventListener('click', () => this.step(1), { signal });
        this.controls.addEventListener('click', (event) => {
          const button = event.target.closest('[data-carousel-page]');
          if (button && this.controls.contains(button)) this.move(Number(button.dataset.carouselPage));
        }, { signal });
        this.grid.addEventListener('scroll', () => this.updateActivePage(), { passive: true, signal });
        this.resizeObserver = new ResizeObserver(() => this.refreshPages());
        this.resizeObserver.observe(this.grid);
        this.refreshPages();
      });
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      this.events?.abort();
      this.resizeObserver?.disconnect();
    }

    refreshPages() {
      const cards = this.grid.querySelectorAll('.hc-product-card');
      const cardWidth = cards[0]?.getBoundingClientRect().width || 0;
      if (!cardWidth || !this.grid.clientWidth) return;

      const style = getComputedStyle(this.grid);
      const gap = parseFloat(style.columnGap) || 0;
      const padding = (parseFloat(style.paddingLeft) || 0) + (parseFloat(style.paddingRight) || 0);
      const stride = cardWidth + gap;
      const visibleCards = Math.max(1, Math.round((this.grid.clientWidth - padding + gap) / stride));
      const maximum = Math.max(0, this.grid.scrollWidth - this.grid.clientWidth);
      this.flow = style.direction === 'rtl' ? -1 : 1;
      this.pages = [0];

      for (let index = visibleCards; index < cards.length; index += visibleCards) {
        const position = Math.min(maximum, index * stride);
        if (position > this.pages[this.pages.length - 1] + 2) this.pages.push(position);
      }

      this.dots.hidden = this.pages.length < 2;
      this.arrows.hidden = this.pages.length < 2;
      if (this.dots.children.length !== this.pages.length) {
        const buttons = this.pages.map((position, index) => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'hc-collection-showcase__dot';
          button.dataset.carouselPage = index;
          button.setAttribute('aria-label', 'Show product group ' + (index + 1) + ' of ' + this.pages.length);
          button.setAttribute('aria-controls', this.grid.id);
          return button;
        });
        this.dots.replaceChildren(...buttons);
      }
      this.updateActivePage();
    }

    updateActivePage() {
      if (!this.pages?.length) return;
      const position = Math.abs(this.grid.scrollLeft);
      this.previous.disabled = position <= 2;
      this.next.disabled = position >= this.pages[this.pages.length - 1] - 2;
      const active = this.pages.reduce((nearest, target, index) =>
        Math.abs(target - position) < Math.abs(this.pages[nearest] - position) ? index : nearest, 0);
      Array.from(this.dots.children).forEach((button, index) => {
        if (index === active) button.setAttribute('aria-current', 'true');
        else button.removeAttribute('aria-current');
      });
    }

    step(direction) {
      const position = Math.abs(this.grid.scrollLeft);
      let index;
      if (direction > 0) {
        index = this.pages.findIndex(target => target > position + 2);
      } else {
        for (index = this.pages.length - 1; index >= 0; index--) {
          if (this.pages[index] < position - 2) break;
        }
      }
      if (index >= 0) this.move(index);
    }

    move(index) {
      if (this.pages[index] === undefined) return;
      this.grid.scrollTo({
        left: this.pages[index] * this.flow,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
